import type { PayViaLinkDetailsAppVm } from '../../application/viewModels/payment.app.vm';

export interface PayViaLinkDetailsVm {
  paymentSource?: string;
  amount: number;
  currency: string;
  orderId: string;
  txnId?: string;
  merchantName: string;
  totalItems: number;
  savings: number;
  razorpayKeyId: string;
  razorpayCustomerId?: string;
  expiresAt?: number;
}

export function toPayViaLinkDetailsVm(
  details: PayViaLinkDetailsAppVm
): PayViaLinkDetailsVm {
  return {
    paymentSource: details.paymentSource,
    amount: details.amount,
    currency: details.currency,
    orderId: details.orderId,
    txnId: details.txnId,
    merchantName: details.merchantName,
    totalItems: details.totalItems,
    savings: details.savings,
    razorpayKeyId: details.razorpayKeyId,
    razorpayCustomerId: details.razorpayCustomerId,
    expiresAt: details.expiresAt,
  };
}
